<template>
  <section style="height: 500px; max-height: 100vh" class="flex column q-pa-lg">
    <slot></slot>
  </section>
</template>
